<template>
    <section class="top-content page-content notfound-section">
        <div class="notfound-container">
            <div class="notfound-group">
                <v-img
                    contain
                    class="notfound-image"
                    :src="require('@/assets/page-not-found.png')"
                ></v-img>
                <span v-if="!hasErrorCode" class="notfound-title"
                    >Something went wrong here.</span
                >
                <span v-if="!hasErrorCode" class="notfound-subtitle">
                    We’re working on it and we’ll get it fixed as soon as
                    possible.
                    <br />You can go to the Nexon Game Card home page or return
                    to the previous page.
                </span>
                <span v-if="hasErrorCode" class="notfound-title"
                    >404 file not found</span
                >
                <span v-if="hasErrorCode" class="notfound-subtitle">
                    The page you requested may have been moved or deleted.
                </span>
                <div class="btn-group">
                    <v-btn
                        class="notfound-home-btn"
                        color="primary"
                        depressed
                        rounded
                        :ripple="false"
                        to="/"
                        >HOME</v-btn
                    >
                    <v-btn
                        class="notfound-back-btn"
                        depressed
                        rounded
                        :ripple="false"
                        @click="$router.go(-1)"
                        >BACK</v-btn
                    >
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'PageNotFound',
    computed: {
        hasErrorCode() {
            return !!this.$route.query.error;
        },
    },
};
</script>
<style lang="scss" scoped>
.notfound-section {
    position: relative;
    height: 100vh;
    min-height: 600px;
    .notfound-container {
        padding-top: 50px;
        .notfound-group {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            .notfound-image {
                width: 211px;
                height: 119px;
            }
            .notfound-title {
                font-family: KlavikaNX-Medium, serif;
                font-size: 30px;
                line-height: 1.13;
                letter-spacing: -0.75px;
                padding-top: 40px;
            }
            .notfound-subtitle {
                font-family: Arial, serif;
                font-size: 16px;
                line-height: 1.63;
                letter-spacing: -0.4px;
                color: #000000;
                padding-top: 25px;
            }
            .btn-group {
                padding-top: 40px;
                min-width: 360px;
                .notfound-home-btn {
                    border-radius: 27px;
                    margin-right: 4.5px;
                }
                .notfound-back-btn {
                    border-radius: 27px;
                    margin-left: 4.5px;
                }
            }
        }
    }
}
.notfound-home-btn.v-btn:not(.v-btn--round).v-size--default {
    width: 147px;
    height: 54px;
}
.notfound-back-btn.v-btn:not(.v-btn--round).v-size--default {
    width: 147px;
    height: 54px;
    background-color: #fff;
    color: #2960e8;
    border: solid 2px #2960e8;
}

@media (min-width: 361px) {
    .notfound-section {
        .notfound-container {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding-top: 0;
            padding-bottom: 50px;
            .notfound-group {
                width: calc(100vw - 60px);
                .notfound-image {
                    width: 250px;
                    height: 140px;
                }
                .notfound-title {
                    font-size: 32px;
                    letter-spacing: -0.8px;
                }
                .notfound-subtitle {
                    line-height: 1.56;
                    padding-top: 20px;
                }
                .btn-group {
                    min-width: 369px;
                }
            }
        }
    }
    .notfound-home-btn.v-btn:not(.v-btn--round).v-size--default {
        width: 180px;
    }
    .notfound-back-btn.v-btn:not(.v-btn--round).v-size--default {
        width: 180px;
    }
}

@include break('sm') {
    .notfound-section .notfound-container .notfound-group {
        .notfound-image {
            width: 291px;
            height: 163px;
        }
        .notfound-title {
            font-size: 36px;
            letter-spacing: -0.9px;
            padding-top: 60px;
        }
        .notfound-subtitle {
            font-size: 18px;
        }
        .btn-group {
            padding-top: 60px;
        }
    }
}

@include break('md') {
    .notfound-section .notfound-container .notfound-group {
        .notfound-title {
            font-size: 40px;
            letter-spacing: -1px;
        }
    }
}
</style>
